import './Secondfloor.css'
import Footer from '../../components/Footer/Footer.jsx';
import ImageCard from '../../components/ImageCard/ImageCard.jsx';
import cab_7_1 from '../../images/Cab_photos/cab_7/IMG20250325111404.jpg'
import cab_7_2 from '../../images/Cab_photos/cab_7/IMG20250325111434.jpg'
import cab_8_1 from '../../images/Cab_photos/cab_8/IMG20250325111536.jpg'
import cab_8_2 from '../../images/Cab_photos/cab_8/1742983900100.jpg'
import cab_8_3 from '../../images/Cab_photos/cab_8/1742983900104.jpg'
import cab_10_1 from '../../images/Cab_photos/cab_10/1742982551200.jpg'
import cab_10_2 from '../../images/Cab_photos/cab_10/IMG20250325111853.jpg'
import cab_11_1 from '../../images/Cab_photos/cab_11/IMG20250325105155.jpg'
import cab_13_1 from '../../images/Cab_photos/cab_13/IMG20250325104248.jpg'
import cab_13_2 from '../../images/Cab_photos/cab_13/1742982551183.jpg'
import cab_13_3 from '../../images/Cab_photos/cab_13/1742982551208.jpg'
import med1 from '../../images/Cab_photos/med/1.jpg'
import med2 from '../../images/Cab_photos/med/2.jpg'
import cab_7_3 from '../../images/Cab_photos/cab_7/4.jpg'
import cab_7_4 from '../../images/Cab_photos/cab_7/5.jpg'
import cab_7_5 from '../../images/Cab_photos/cab_7/6.jpg'
import cab_11_2 from '../../images/Cab_photos/cab_11/4.jpg'
import sportzal from '../../images/Cab_photos/sportzal/1742983142545.png'
import cab_23_1 from '../../images/Cab_photos/cab_23/1742984932891.jpg'
import cab_23_2 from '../../images/Cab_photos/cab_23/1742984932902.jpg'
import { Link } from 'react-router-dom';


function Secondfloor() {
  return (
    <>
    <div className='wrap'>
    <div className="Secondfloor">

        <ImageCard title={'Кабинет биологии'} 
        images={[cab_7_3, cab_7_2,cab_7_1 , cab_7_4, cab_7_5]}
        description={'Это специально оборудованное помещение для организации учебно-воспитательного процесса по биологии. Оно состоит из двух смежных комнат: классного помещения и лаборантской. Электронная панель используются для демонстрации наглядных пособий на уроке.  Наглядные пособия применяются при изучении разных тем и учебных курсов.'}/>

        <ImageCard 
        images={[cab_23_1, cab_23_2]}
        description={'Здесь проходят уроки и консультации по математике. В кабинете сосредоточено оборудование, позволяющее вести эффективное преподавание математики, созданы условия для успешного использования всех средств обучения.'}
        title={'Кабинет математики'}/>

        <ImageCard title={'Кабинет русского языка'} 
        images={[cab_8_1, cab_8_2, cab_8_3]}
        description={'Это просторная светлая комната с большими окнами. На стенах висят грамматические таблицы, наглядные пособия, высказывания писателей о русском языке, их портреты и плакаты. В шкафах хранятся книги, журналы и различные учебные пособия по русскому языку. Кабинет оснащён техническими средствами обучения. '}/>

        <ImageCard title={'Кабинеты начальных классов'} 
        images={[cab_10_2, cab_10_1, cab_13_1, cab_13_2, cab_13_3]}
        description={'Это специально оборудованные классные комнаты, где проводятся уроки и внеурочные мероприятия для младших школьников. Кабинеты оснащены необходимыми средствами обучения, которые используются в соответствии с учебниками и программами: карты по окружающему миру, альбомы по изобразительному искусству, таблицы, схемы по математике, технические средства обучения и другие. Слева на стендах располагаются таблицы по изучаемым темам, классные уголки, уголки с символикой России.'}/>

        <ImageCard 
        title={'Медицинский кабинет'}
        description={'Здесь наши медики могут и температуру померить, и укол, если нужно, сделать. Не забывают они и про профилактические прививки. Также здесь проходят ежегодные медицинские осмотры.'}
        images={[med1, med2]}/>

        <ImageCard title={'Кабинет химии'} 
        images={[cab_11_1, cab_11_2]}
        description={'Это специально оборудованное помещение для проведения теоретических и практических занятий по этому предмету. Оно состоит из двух смежных комнат: классного помещения и лаборантской. Здесь ребята проводят химические опыты,  используя современное оборудование — прямо как в настоящей лаборатории.'}/>

        <ImageCard
        images={[sportzal]}
        description={'В спортивном зале проходят уроки физической культуры, спортивные соревнования,  турниры по футболу и баскетболу, спортивному ориентированию. '}
        title={'Спортивный зал'}/>
    </div>
    <div className='buttonwrap'>
    <div className="next-floor-button-container">
            <Link to="/First_floor" className="next-floor-button">
            ← Перейти на 1 этаж 
            </Link>
    </div>
    <h3>Или</h3>
    <div className="next-floor-button-container">
            <Link to="/Thirdfloor" className="next-floor-button">
              Перейти на 3 этаж →
            </Link>
    </div>
    </div>
    </div>
    <Footer/>
    </>
  );
}

export default Secondfloor;
